export const makeEntity = (array, selectId) => array.reduce(({ ids, entities }, item, i) => {
    const id = `${selectId ? item[selectId] : i}`;
    return {
        ids: [...ids, id],
        entities: Object.assign(Object.assign({}, entities), { [id]: selectId ? item : Object.assign({ id }, item) }),
    };
}, { ids: [], entities: {} });
